module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('media-player', {
    attrs: {
      "issue": _vm.issue,
      "share": false,
      "header": false
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('p'), _c('h3', [_c('i', [_vm._v("Interview with Dr. Somebody Somename & Somebody Othername")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n      Division of Molecular Carcinogenesis, The Netherlands Cancer Institute, Amsterdam, The Netherlands\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      talking about their cover paper published in "), _c('i', [_c('a', [_vm._v("Volume 7 Issue 25")])]), _vm._v(" of Oncotarget called "), _c('a', [_c('b', [_vm._v("\"Intrinsic resistance\n      to PIM kinase inhibition in AML through p38α-mediated feedback activation of mTOR signaling\"")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8943e1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/InterviewVideoComponent.vue
// module id = 1475
// module chunks = 1